<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="openDialog = true">
                <v-list-tile-content>
                  <v-list-tile-title>IMPORT EXCEL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="printAllLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="printAll('printAll')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAll()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="accName"
                label="Name"
                type="text"
                v-model="queryParams.accName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="accountHeadList"
                label="Account Head"
                v-model="queryParams.accountheadId"
                item-text="accountName"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="typeList"
                label="Account Type"
                v-model="queryParams.type"
                item-text="accTypeName"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="natureList"
                label="Nature"
                v-model="queryParams.nature"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="chartOfAccountList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>
                <v-icon
                  v-if="props.item.status == 'ACTIVE'"
                  medium
                  color="green"
                  >check_circle</v-icon
                >
                <v-icon v-else medium color="red">cancel</v-icon>
              </td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.accName }}</td>
              <td>{{ props.item.accType.accTypeName }}</td>
              <td>{{ props.item.nature }}</td>
              <td>{{ props.item.accounthead.accountName }}</td>
              <td>{{ props.item.parentCode }}</td>
              <td>
                {{
                  props.item.updatedDateInMilliSeconds
                    | format-ms-date-time
                }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <summary report> -->
    <div
      id="printAll"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">Chart Of Accounts</p>
      </div>
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="text-align: left">Code</th>
              <th style="text-align: left">Name</th>
              <th style="text-align: left">Account Type</th>
              <th style="text-align: left">Nature</th>
              <th style="text-align: left">Account Head</th>
              <th style="text-align: left">Parent Code</th>
              <th style="text-align: left">Updated Date</th>
              <th style="text-align: left">Updated By</th>
              <th style="text-align: left">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allChartOfAccountList" :key="index">
              <td style="text-align: left">{{ item.code }}</td>
              <td style="text-align: left">{{ item.accName }}</td>
              <td style="text-align: left">{{ item.accountTypeName }}</td>
              <td style="text-align: left">{{ item.nature }}</td>
              <td style="text-align: left">
                {{ item.accounthead.accountName }}
              </td>
              <td style="text-align: left">{{ item.parentCode }}</td>
              <td style="text-align: left">
                {{ item.updatedDateInMilliSeconds | format-ms-date }}
              </td>
              <td style="text-align: left">{{ item.updatedBy }}</td>
              <td style="text-align: left">{{ item.status }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <chartOfAccountExcel
      :isOpen="openDialog"
      v-on:change="dialogClose()"
    ></chartOfAccountExcel>
  </v-container>
</template>
<script>
import { chartOfAccountService } from "../../services/chart-of-account-service";
import { accountTypeService } from "../../services/account-type-service";
import { accountHeadService } from "../../services/account-head-service";
import { commonService } from "../../services/common-service";
import chartOfAccountExcel from "../../components/chartofaccount/ChartOfAccountExcel";
export default {
  name: "ChartOfAccountList",
  components: { chartOfAccountExcel },
  data: () => ({
    showListLoading: false,
    openDialog: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Finance",
        disabled: true,
      },
      {
        text: "Chart Of Account",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", value: "name", sortable: false },
      { text: "Status", value: "status" },
      { text: "Code", align: "left", value: "code" },
      { text: "Name", value: "accName" },
      { text: "Account Type", value: "accType.accTypeName" },
      { text: "Nature", value: "nature" },
      { text: "Account Head", value: "accountHead.accountName" },
      { text: "Parent Code", value: "accountChild.code" },
      { text: "Updated Date", value: "createdDate" },
      { text: "Updated By", value: "createdBy" },
    ],
    statusList: [
      { label: "All", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" },
    ],
    typeList: [],
    accountHeadList: [],
    natureList: [
      { label: "All", value: "" },
      { label: "DR", value: "DR" },
      { label: "CR", value: "CR" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    chartOfAccountList: [],
    totalRows: 0,
    printAllLoading: false,
    clonequeryParams: new Object(),
    allChartOfAccountList: [],
    queryParams: {
      accName: "",
      code: "",
      accountheadId: "",
      type: "",
      nature: "",
      status: "",
    },
  }),
  watch: {
    pagination: {
      handler() {
        this.getChartOfAccountList();
      },
      deep: true,
    },
  },

  created() {
    //for deep linking
    if (this.$route.query.accName) {
      this.queryParams.accName = this.$route.query.accName;
    }
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.accountheadId) {
      this.queryParams.accountheadId = this.$route.query.accountheadId;
    }
    if (this.$route.query.type) {
      this.queryParams.type = this.$route.query.type;
    }
    if (this.$route.query.nature) {
      this.queryParams.nature = this.$route.query.nature;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getAccountTypeList();
    this.getAllAccountHeadList();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "chart-of-accounts",
        query: this.queryParams,
      });
      this.getChartOfAccountList();
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
    },
    getAccountTypeList() {
      accountTypeService
        .getAccountTypeByStatus("ACTIVE")
        .then((res) => {
          this.typeList = res.data;
          let all = {
            id: "",
            accTypeName: "All",
          };
          this.typeList.splice(0, 0, JSON.parse(JSON.stringify(all)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllAccountHeadList() {
      accountHeadService
        .getAllAccountHead()
        .then((res) => {
          this.accountHeadList = res.data;
          let all = {
            id: "",
            accountName: "All",
          };
          this.accountHeadList.splice(0, 0, JSON.parse(JSON.stringify(all)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getChartOfAccountList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      chartOfAccountService
        .getChartOfAccountList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.chartOfAccountList = res.data.chartOfAccountList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/chart-of-account/new");
    },
    onEdit(chartOfAccount) {
      // go to details page
      this.$router.push("/chart-of-account/" + chartOfAccount.id);
    },
    dialogClose() {
      this.openDialog = false;
      this.getChartOfAccountList();
    },
    exportAll() {
      this.printAllLoading = true;
      chartOfAccountService
        .exportAllChartOfAccount(this.clonequeryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printAllLoading = false;
        });
    },
    printAll(divName) {
      this.printAllLoading = true;
      chartOfAccountService
        .getAllChartOfAccountList(this.clonequeryParams)
        .then((res) => {
          if (res.data) {
            this.allChartOfAccountList = res.data.chartOfAccountList;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllLoading = false;
        });
    },
  },
};
</script>